const initialEditorState = () => {
  return {
    oldPassword: '',
    newPassword: '',
  };
};

export default initialEditorState;
